<cotecna-toolbar
  [options]="toolbarOptions"
  (actionClicked)="onToolbarActionClicked($event)"
></cotecna-toolbar>

<mat-horizontal-stepper
  #stepper
  [linear]="true"
  (selectionChange)="onStepSelectionChange($event, stepper)"
  labelPosition="bottom"
>
  <!-- General Info -->
  <mat-step [completed]="isGeneralInfoReady && inspectionNameIsCorrect">
    <ng-template matStepLabel>General Information</ng-template>

    <div class="stepper-actions">
      <span class="spacer"></span>
      <button
        id="GeneralInfoNextButton"
        [disabled]="!isGeneralInfoReady"
        (click)="checkNameAndNext(stepper)"
        mat-stroked-button
        color="primary"
      >
        Next
      </button>
    </div>

    <div class="content">
      <im-general-info
        *ngIf="
          selectedStepIndex == 0 &&
            presets &&
            inspection &&
            !generalInfoLoading;
          else loading
        "
        [currentPreset]="currentPreset"
        [id]="inspection.id"
        [existingData]="inspection.generalInfo"
        [originApplicationName]="inspection.originApplicationName"
        [externalId]="inspection.generalInfo.externalId"
        [clientId]="inspection.clientId"
        [presets]="presets"
        (formChange)="onGeneralInfoChanged($event)"
        (presetChange)="onPresetChange($event)"
      >
      </im-general-info>
      <ng-template #loading>
        <mat-spinner diameter="32"></mat-spinner>
      </ng-template>
    </div>
  </mat-step>

  <!-- Products -->
  @if (!isAccountTypeManagementOnly) {
    <mat-step [completed]="isItemsReady">
      <ng-template matStepLabel>Items</ng-template>

      <div class="stepper-actions">
        <button mat-stroked-button matStepperPrevious>Back</button>
        <span class="spacer"></span>
        <button
          [disabled]="!isItemsReady"
          mat-stroked-button
          color="primary"
          matStepperNext
        >
          Next
        </button>
      </div>

      <div class="content">
        <im-items-creation
          *ngIf="selectedStepIndex == 1 && !itemsLoading; else loading"
          [config]="productsListConfig"
          [defaultFormId]="itemsFormId"
          [allowToDisableSections]="true"
          [toggleSectionsForForm]="toggleItemsList"
          [items]="inspection.itemsInfo.items"
          (toggleChanged)="
            onToggleItemsListChanged($event.formId, $event.sectionId)
          "
          (itemsAdded)="onItemsAdded($event)"
          (itemDeleted)="onItemDeleted($event)"
          (itemEdited)="onItemEdited($event)"
        >
        </im-items-creation>
        <ng-template #loading>
          <mat-spinner diameter="32"></mat-spinner>
        </ng-template>
      </div>
    </mat-step>
  }

  <!-- Scope of Work Form -->
  @if (!isAccountTypeManagementOnly) {
    <mat-step [completed]="isScopeOfWorkReady">
      <div class="stepper-actions">
        <button mat-stroked-button matStepperPrevious>Back</button>
        <span class="spacer"></span>
        <div
          [matTooltipDisabled]="isScopeOfWorkReady"
          matTooltip='Inspections must have either at least an "Item" or a task on this tab to proceed.'
        >
          <button
            id="SowNextButton"
            [disabled]="!isScopeOfWorkReady"
            mat-stroked-button
            color="primary"
            matStepperNext
          >
            Next
          </button>
        </div>
      </div>

      <ng-template matStepLabel>Scope of Work Form</ng-template>
      <div class="content">
        <im-sow-creation
          *ngIf="selectedStepIndex == 2"
          [sections]="inspection.scopeOfWork.form.sections"
          [controls]="inspection.scopeOfWork.form.controls"
          [formValues]="inspection.scopeOfWork.values"
          [config]="scopeOfWorkConfig"
          [defaultFormId]="sowFormId"
          [toggleSections]="toggleSowList"
          [created]="inspectionIsCreated"
          [presets]="presets"
          [selectedPreset]="inspection.presetId"
          [sowScreens]="sowScreens"
          (toggleChanged)="onToggleSowListChanged($event)"
          (sowFormChanged)="onSowFormChanged($event)"
        >
        </im-sow-creation>
      </div>
    </mat-step>
  }

  <!-- Inspectors Assignment -->
  <mat-step>
    <ng-template matStepLabel>Inspectors</ng-template>

    <div class="stepper-actions">
      <button mat-stroked-button matStepperPrevious>Back</button>
      <span class="spacer"></span>
      <button
        id="perform-action-button"
        [disabled]="isButtonDisabled()"
        (click)="performAction()"
        mat-raised-button
        color="accent"
      >
        {{ getButtonText() }}
      </button>
    </div>

    <div class="content">
      @if (canGetInspectorsContainer) {
        <im-inspectors-container
          [alreadyAssigned]="inspection?.users"
          [newGeneralInfo]="inspection?.generalInfo"
          (inspectorAssigned)="onInspectorAssigned($event)"
          (inspectorUnassigned)="onInspectorUnassigned($event)"
        >
        </im-inspectors-container>
      }
    </div>
  </mat-step>
</mat-horizontal-stepper>
